import { LoginEffects } from '@modules/autenticacion/login/store/effects';

export const effects = [LoginEffects];
